export const headerWidgetContent = [
  {
    header: "Nature of Business",
    para: "Distributor",
    icon: "fa fa-hospital-o",
  },
  {
    header: "GST Number",
    para: "29AAJFK0118Q1ZX",
    icon: "fa fa-user-md",
  }
];
